module.exports = __webpack_public_path__ + "static/img/natura1.f31897e0.jpg";